"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipContent = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const TooltipContent = exports.TooltipContent = _styledComponents.default.div`
  font-size: ${props => props.fontSize};
`;